import { apiAxiosCMS } from 'services/api';
import { BannerPlpProps } from 'types/BannerPlpProps';

export async function getPlpBanners(handleNotify: any) {
	let banners: BannerPlpProps[] = [];
	await apiAxiosCMS
		.get('/plp-banner')
		.then((res) => {
			if (res.data.length > 0) {
				res.data.forEach((element: any) => {
					if (!('collections' in element)) {
						element.collections = [];
					}

					banners.push(element);
				});

				banners = res.data;
			}
		})
		.catch(() => {
			banners = [];
			handleNotify(
				'Erro ao buscar os banners, tente novamente mais tarde.',
				'error'
			);
		});

	return banners;
}
